// extracted by mini-css-extract-plugin
module.exports = {"howStoresWork":"how-stores-work_howStoresWork__fFEP9"};